<app-mu-sidebar
  customClass="express-add-card-modal-anchor express-add-card-content"
  [contentClass]="customClass"
  [flagList]="flagList"
  [showFlag]="showFlag"
  [skin]="skin"
>
  <form class="p-grid mu-form-content" [formGroup]="formData" appValidator autocomplete="off">
    <app-mu-form-section [gridSizeForm]="12" class="mu-full-width" [withAbsoluteButtons]="true">
      <div class="p-grid">
        <div class="p-col-12 mu-payments-recharge-right-logo">
          <img class="img-kushki" src="/assets/images/pse.png" alt="logo-pse" />
        </div>
        <div class="p-col-12 mu-payments-recharge-right-copy mu-without-padding" [innerHTML]="'common.copyRight' | translate"></div>

        <app-mu-form-fieldset label="bankId" [customGridCol]="12" class="mu-without-padding">
          <app-mu-form-dropdown [formGroup]="formData" field="bankId" [filter]="true" [optionList]="kushkiBankList"></app-mu-form-dropdown>
        </app-mu-form-fieldset>

        <app-mu-form-fieldset label="userType" [customGridCol]="12" [customGridColLg]="6" class="mu-padding-right">
          <app-mu-form-dropdown [formGroup]="formData" field="userType" [optionList]="userTypeList"></app-mu-form-dropdown>
        </app-mu-form-fieldset>

        <app-mu-form-fieldset label="documentTypePse" [customGridCol]="12" [customGridColLg]="6" class="mu-padding-left">
          <app-mu-form-dropdown [formGroup]="formData" field="documentType" [optionList]="documentTypeList"></app-mu-form-dropdown>
        </app-mu-form-fieldset>

        <div class="document-number-pse p-grid">
          <app-mu-form-fieldset label="documentNumberPse" [customGridCol]="12">
            <input
              pInputText
              id="documentNumber"
              type="text"
              label="documentNumberPse"
              name="documentNumber"
              placeholder="{{ 'form.placeholder.documentNumberPse' | translate }}"
              formControlName="documentNumber"
            />
          </app-mu-form-fieldset>

          <app-mu-form-fieldset
            class="{{ showVerificationDigit ? 'show-dv' : 'hide-dv' }}"
            label="verificationDigit"
            tooltipText="{{ 'tooltip.verificationDigit' | translate }}"
            [customGridCol]="12"
          >
            <input
              pInputText
              id="verificationDigit"
              type="text"
              label="verificationDigit"
              name="verificationDigit"
              placeholder="{{ 'form.placeholder.verificationDigit' | translate }}"
              formControlName="verificationDigit"
              [maxlength]="1"
            />
          </app-mu-form-fieldset>
        </div>

        <app-mu-form-fieldset label="fullNamePse" [customGridCol]="12" [slimPadding]="true" class="mu-without-padding">
          <input
            pInputText
            id="name"
            type="text"
            label="fullNamePse"
            name="name"
            placeholder="{{ 'form.placeholder.fullNamePse' | translate }}"
            formControlName="name"
          />
        </app-mu-form-fieldset>

        <app-mu-form-buttons [customGridCol]="12" [alwaysFullWidth]="false" class="mu-payments-recharge-right-buttons mu-without-padding">
          <p-button
            muButtonLeft
            [label]="'form.button.cancel' | translate"
            class="mu-button mu-button-outline"
            type="button"
            (click)="cancel()"
          >
            <span></span>
          </p-button>
          <p-button
            muButtonRight
            [label]="'form.button.savePse' | translate"
            class="mu-button mu-button-full-width button-submit"
            type="button"
            (click)="save()"
            [disabled]="formData.get('isInvalidForm').value"
          >
            <app-loading [showLoading]="flagList?.get(loaderFlag)" type="icon"></app-loading>
          </p-button>
        </app-mu-form-buttons>
      </div>
    </app-mu-form-section>
  </form>
</app-mu-sidebar>
